// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__5LEpH","label":"SetPasswdForm_label__2uSUs"};